import React from 'react';
import {Route, Switch, useLocation, useParams} from 'react-router-dom';
import KanbanTable from "../kanban/KanbanTable";
import RequirementsMode from "./RequirementsMode";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const AppWithRouterAccess = (props) => {
    let location = useLocation();
    let urlParams = useParams();
    console.log("AppWithRouterAccess location:", location, ", urlParams:", urlParams);

    console.log("AppWithRouterAccess props:", props);

    let server = props.server;

    const globals = {
        server: server,
        metamodel: "happymade",
        authorized: !!props.user,
        get: async (request) => {
            return fetch(server + request, {
                headers: {
                    Authorization: await props.getAuthorization(),
                },
            });
        },
        deleteElement: async (element) => {
            return fetch(`${server}/model/${element.type}/${element.id}`, {
                method: "DELETE",
                headers: {
                    Authorization: await props.getAuthorization(),
                },
            });
        },
        put: async (request, values) => {
            return fetch(server + request, {
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                    Authorization: await props.getAuthorization(),
                },
                body: JSON.stringify(values),
            });
        },
        updateElement: async (element, values) => {
            return fetch(`${server}/model/${element.type}/${element.id}`, {
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                    Authorization: await props.getAuthorization(),
                },
                body: JSON.stringify(values),
            });
        },
        createChild: async (parent, collection, values) => {
            return fetch(`${server}/model/${parent.type}/${parent.id}/${collection}`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                    Authorization: await props.getAuthorization(),
                },
                body: JSON.stringify(values),
            });
        },
        addLink: async (element, collection, target) => {
            return fetch(`${server}/model/${element.type}/${element.id}/${collection}/${target.type}/${target.id}`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                    Authorization: await props.getAuthorization(),
                },
            });
        },
        removeLink: async (element, collection, target) => {
            return fetch(`${server}/model/${element.type}/${element.id}/${collection}/${target.type}/${target.id}`, {
                method: "DELETE",
                headers: {
                    Authorization: await props.getAuthorization(),
                },
            });
        },
    };
    console.log("AppWithRouterAccess authorized:", globals.authorized);

    return (
            <Switch>
                <Route path="/kanban">
                    <KanbanTable
                        globals={globals}
                        product="1"
                        metamodel={globals.metamodel}/>
                </Route>
                <Route path="/:mode?">
                    <RequirementsMode
                        globals={globals}
                        metamodel={globals.metamodel}
                        user={props.user}
                    />
                </Route>
            </Switch>
    );
};

export default AppWithRouterAccess;